import "core-js/modules/es.array.push.js";
import { logout } from '@/api/login';
import NavMenu from '@/layout/components/NavMenu/index.vue';
export default {
  name: 'Header',
  components: {
    NavMenu
  },
  data() {
    return {
      hiddenGlobalNav: false,
      head: null,
      name: '游客',
      schoolName: '游客',
      navShow: false
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  created() {
    this.hiddenGlobalNav = sessionStorage.getItem('hiddenGlobalNav');
    this.getInfo();
  },
  methods: {
    // 显示/隐藏弹框
    subNavShow() {
      this.navShow = !this.navShow;
    },
    // 获取信息
    getInfo() {
      this.head = sessionStorage.getItem('teacherHead');
    },
    // 账号设置
    set() {
      this.$router.push({
        name: 'manage'
      });
    },
    // 去首页
    goHome() {
      this.$router.push({
        name: 'home'
      });
    },
    // 退出登录
    async logout() {
      try {
        await logout();
        this.$store.commit('clearInclude');
        this.$store.commit('setUserInfo', {});
        sessionStorage.clear();
        this.common.globalData.gradeTypeId = null;
        this.common.globalData.provinceId = null;
        this.common.globalData.cityId = null;
        await this.$router.push({
          name: 'login'
        });
      } catch (e) {}
    }
  }
};